<div class="modal-content">
  <div class="modal-header">Usuários</div>
  <div class="modal-body p-0 user-scroll">
    <app-status #status></app-status>

    <div class="list-group list-group-flush scrolly" *ngIf="!status.visible">
      <button type="button" class="list-group-item list-group-item-action" *ngFor="let user of users"
        [class.active]="user.selected" (click)="user.selected = !user.selected; unselectOthers(user.id)">
        {{ user.name }}
      </button>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="ok($event)">OK</button>
    <button type="button" class="btn btn-secondary" (click)="bsModalRef.hide()">Cancelar</button>
  </div>
</div>
